/**
 * Button Component - Component Definition
 * =======================================
 */

import angular, { IModule, IComponentOptions } from 'angular';

import { ButtonController } from './controller';
import { BUTTON_TEMPLATE } from './template';
import {
  INTENT_EMPHASIS,
  INTENT_RING,
  SIZES,
  SHAPES,
  BASE_CLASSES,
  ICONS,
  SPINNER_SVG,
  DEFAULTS,
  ButtonIntent,
  ButtonEmphasis,
  ButtonSize,
  ButtonShape,
  ButtonType,
  ButtonIconType
} from './constants';

export interface IButtonComponentBindings {
  intent?: ButtonIntent;
  emphasis?: ButtonEmphasis;
  size?: ButtonSize;
  shape?: ButtonShape;
  block?: boolean;
  label?: string;
  subtitle?: string;
  leadingIcon?: ButtonIconType;
  trailingIcon?: ButtonIconType;
  disabled?: boolean;
  loading?: boolean;
  type?: ButtonType;
  onClick?: (args: { $event: Event }) => void;
}

export const buttonComponentDefinition: IComponentOptions = {
  template: BUTTON_TEMPLATE,
  controller: ButtonController,
  transclude: true,
  bindings: {
    intent: '@',
    emphasis: '@',
    size: '@',
    shape: '@',
    block: '<',
    label: '@',
    subtitle: '@',
    leadingIcon: '@',
    trailingIcon: '@',
    disabled: '<',
    loading: '<',
    type: '@',
    onClick: '&?'
  }
};

export const MODULE_NAME = 'ec.button';

const buttonModule: IModule = angular
  .module(MODULE_NAME, ['ngSanitize'])
  .component('ecButton', buttonComponentDefinition);

export {
  ButtonController,
  BUTTON_TEMPLATE,
  INTENT_EMPHASIS,
  INTENT_RING,
  SIZES,
  SHAPES,
  BASE_CLASSES,
  ICONS,
  SPINNER_SVG,
  DEFAULTS
};

export type {
  ButtonIntent,
  ButtonEmphasis,
  ButtonSize,
  ButtonShape,
  ButtonType,
  ButtonIconType
} from './constants';

export default buttonModule;
